<app-z-dialog
  [title]="data.title | translate"
  [customTitleTemplate]="titleTemplate"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #titleTemplate>
  <div class="approve-dialog-header flex-grow-1">
    <h4 class="dialog-title s-mb-1 fw-bold c-white">
      {{ data.title | translate }}
    </h4>
    @if (data.message) {
      <p class="approve-dialog-header__message">
        {{ data.message | translate }}
      </p>
    }
  </div>
</ng-template>

<ng-template #contentTemplate>
  <section class="d-flex flex-column align-items-center" [formGroup]="form">
    <mat-button-toggle-group
      formControlName="decision"
      class="decision-toggle-group"
      hideSingleSelectionIndicator
    >
      <mat-button-toggle value="approved" class="toggle-approved">
        <mat-icon>check_circle</mat-icon>
        Aprovado
      </mat-button-toggle>

      <mat-button-toggle value="pending" class="toggle-pending">
        <mat-icon>pending_actions</mat-icon>
        Pendência
      </mat-button-toggle>

      <mat-button-toggle value="rejected" class="toggle-rejected">
        <mat-icon>cancel</mat-icon>
        Rejeitado
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="mt-4 w-100">
      <z-form-grid
        *ngIf="data.fields?.length"
        [inputs]="data.fields ?? []"
        [formGroupRef]="form"
      ></z-form-grid>
      <z-input
        [label]="'COMMON.OBSERVATIONS' | translate"
        [formControlRef]="form.controls['observations']"
        [type]="'textarea'"
        class="col-md-12 w-100"
      >
      </z-input>
    </div>
  </section>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    icon="send"
    [label]="'COMMON.SEND' | translate"
    (clicked)="confirm()"
    [disabled]="form.invalid"
  ></z-button>
</ng-template>
